module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img-2.d33b56d9.jpeg";